import BaseLink from 'prosemirror-to-html-js/src/Marks/Link';
export default class LinkExternal extends BaseLink {
  tag () {
    return [
      {
        tag: "a",
        attrs: {
          href: this.mark.attrs.href,
          target: "_blank",
        }
      }
    ]
  }
}
